<template>
    <div class="list">
        <NavBar></NavBar>
         <!-- <div class="nav">
            <van-nav-bar :title="title" left-text="返回" left-arrow @click-left="onClickLeft" />
        </div> -->
        <!-- 后加的用来跳转路由的 -->
        <!-- <van-button type="primary" size="mini" @click="openUrl">跳转路由的测试</van-button> -->
        <!--  -->
        <van-col span='24'>
            <van-image width="100%" height="100%" :src="imgUrl" />
        </van-col>
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <div v-if="!isShow">
                <van-list v-model:error="error" error-text="请求失败，点击重新加载" v-model:loading="loading" :finished="finished" @load="onLoad">
                    <van-cell-group v-for="item in policyList" :key="item"  :border='false' @click="openStatute(item)">
                        <van-cell  :value='item.createTime' is-link >
                            <template #title>
                                <span class="custom-title">《{{item.title}}》</span>
                            </template>
                        </van-cell>
                    </van-cell-group>
                </van-list>
            </div>
            <div style="padding-top:15px" v-if="isShow">
                <van-empty image="error" description="没有更多" />
            </div>
        </van-pull-refresh>
        <van-divider :style="{ color: 'gray', borderColor: 'gray', padding: '0 16px 100px 16px',fontSize:'12px'}">
            威海南海新区住宅维修资金宣
        </van-divider>
        <div class="flex">
            <van-col :span="24" class="house_button">
                <van-button color="#e1251b" size="normal" @click="goHome" >返回首页</van-button>
            </van-col>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                // title:
      title:this.$route.name,

                refreshing:false,
                error:false,
                imgUrl: require('../../assets/Image/banQ.jpg'),
                policyList:[],
                isShow:false,
                finished:false,
                loading:false
            }
        },
        // 在此处判断一下离开的时候是否是显示的
        mounted(){
            window.onbeforeunload=function(event){
                 alert(event)
                 if(event){
                     event.returnValue ='q12222'
                 }
                 return 'q12222'
                //  debugger
             }
        },
        //watch监听路由跳转 
        // watch:{
        //     '$route.path':function(newVal,oldVal){
        //         console.log(newVal,'1111')
        //         console.log(oldVal)
        //         if(newVal=='/MaintenanceItems'){
        //             this.$router.replace('/')
        //         }
        //     }
        // },
        // 
        methods: {
            // 跳转路由测试
            // openUrl(){
            //     this.$router.push({
            //         path:'/TextOfRegulations'
            //     })
            // },
            // 
            onClickLeft() {
                // history.go(-1);
                this.$router.go(-2)
            },
            goHome(){
                // history.go(-1)
                // window.location.href='https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa8695f877fc9ed55&redirect_uri=http%3A%2F%2Fytwyw.cn&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect'
                // window.location.href='https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxe3a6512ccf114bc4&redirect_uri=http%3a%2f%2fnhzjwxzj.weihai.cn%2findex1.html%23%2f&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect'
                window.location.href='https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa28bd401be12487d&redirect_uri=http%3a%2f%2fnhzjwxzj.weihai.cn%2findex1.html%23%2f&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect'
                // window.location.replace=''
                // this.$router.push({
                //     path: '/'
                // });
            },
            openStatute(item){
                this.$router.push({
                    path:'/TextOfRegulations',
                    query:{
                        id:item.id
                    }
                })
                // this.$router.replace({
                //     path:'/TextOfRegulations',
                //     query:{
                //         id:item.id
                //     }
                // })
            },
            onLoad(){
                let data={
                    noticeType:1,
                    state:1,
                    pageNum:1,
                    pageSize:10
                }
                this.$postQuery('/weChatNotice/getNoticeListByType', data)
                .then((response) => {
                    if (this.refreshing) {
                        this.list = [];
                        this.refreshing = false;
                    }
                    if(response.code==200){
                        this.policyList = response.data.list
                        if(this.policyList.length==0){
                            this.isShow=true
                        }
                        this.loading = false;
                        // 数据全部加载完成
                        if (this.policyList.length >= response.data.list.length) {
                            this.finished = true;
                        }
                    }else{
                        this.isShow = true
                    }
                })
                .catch(()=>{
                    this.error = true;
                    this.loading = false
                })
            },
            onRefresh(){
                // 清空列表数据
                this.finished = false;
                //重新加载数据
                this.loading = true;
                this.onLoad();
            },
        },
        // created(){
        //     alert('11111')
        // }
    }
</script>

<style scoped>
    .custom-title {
        margin-right: 4px;
        vertical-align: middle;
        width: 190px;
        display: inline-block;
        overflow: hidden; /*超出部分隐藏*/
        text-overflow: ellipsis; /* 超出部分显示省略号 */
        white-space: nowrap; /*规定段落中的文本不进行换行 */
    }
    .list {
        margin-top: 46px;
    }
    .flex {
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
    }
    .flex .house_button{
        margin: 10px;
    }
    .flex  .house_button .van-button,.content_button .van-button{
        padding: 3px 15px;
        width: 100%;
    }
</style>